import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? 'success' : 'error');
  };
  return <footer className="bg-linen" data-id="element-17" data-mp="36nd4tff2k623">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 lg:grid-cols-12 lg:px-10" data-id="element-18" data-mp="3ufa6idot1hph">
        <div className="lg:col-span-6" data-id="element-19" data-mp="38qz78i6g9vx">
          <p className="font-display text-6xl font-semibold tracking-[0.25em] text-ink sm:text-7xl" data-id="element-20" data-mp="37fsp0xcko14">AMIRA</p>
          <p className="mt-3 font-display text-2xl italic text-clay" data-id="element-21" data-mp="3ldu52vfywpxe">Pure. Clear. Proven.</p>
        </div>
        <div className="lg:col-span-5 lg:col-start-8" data-id="element-22" data-mp="3qbvnrf9hen8c">
          <h2 className="font-display text-3xl text-ink" data-id="element-23" data-mp="29ynldknsn5e0">Als eerste weten wanneer we lanceren</h2>
          {status === 'success' ? <p className="mt-6 flex items-center gap-2 text-ink" role="status" data-id="element-24" data-mp="2ezuupo5l4cms">
              <CheckIcon className="h-5 w-5 text-clay" aria-hidden="true" data-id="element-25" data-mp="3lalhljipadw2" />
              Dank je. We laten van ons horen.
            </p> : <form onSubmit={submit} className="mt-6" noValidate data-id="element-26" data-mp="3gctnciul2fop">
              <label htmlFor="email" className="sr-only" data-id="element-27" data-mp="3v9az3b6opwbs">E-mailadres</label>
              <div className="flex gap-2" data-id="element-28" data-mp="3q7lmvs7q7cm4">
                <input id="email" type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              if (status === 'error') setStatus('idle');
            }} placeholder="jouw@email.nl" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? 'email-error' : undefined} className="min-w-0 flex-1 rounded-full border border-hairline bg-sand px-5 py-3 text-ink placeholder:text-muted/70 focus:border-ink focus:outline-none" data-id="element-29" data-mp="3qaq0thaztmpz" />
                <button type="submit" className="whitespace-nowrap rounded-full bg-ink px-6 py-3 text-sm font-medium text-sand transition-colors duration-150 hover:bg-clay" data-id="element-30" data-mp="tvw9ald1dni3">
                  Aanmelden
                </button>
              </div>
              {status === 'error' && <p id="email-error" className="mt-2 text-sm text-clay-dark" data-id="element-31" data-mp="18kiyrfwdnvn1">Vul een geldig e-mailadres in.</p>}
            </form>}
        </div>
      </div>
      <div className="border-t border-hairline" data-id="element-32" data-mp="1hkp42ehx9pb4">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-6 py-6 text-sm text-muted sm:flex-row lg:px-10" data-id="element-33" data-mp="1hje0aeoh8hk0">
          <span data-id="element-34" data-mp="1mhpfl4xjjk9m">© 2026 AMIRA</span>
          <span data-id="element-35" data-mp="1rjeoadxajluj">Geïnspireerd door Aït Baha, Marokko</span>
        </div>
      </div>
    </footer>;
}